<template>
	<div v-if="isUserAllowedInLevel2 && isAuthenticatedUserInGroupAdmin">
		<div>
			<BaseHeader :title="$t('pdf_templates').toString()"></BaseHeader>
			<div class="main">
				<div v-if="pdfBlueprints && pdfBlueprints.length">
					<div class="flex flex-col">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
													{{ $t('name') }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200">
											<tr
												class="hover:bg-gray-300 cursor-pointer text-left"
												v-for="pdfBlueprint in pdfBlueprints"
												:key="pdfBlueprint.id"
												@click="redirectToTarget(pdfBlueprint.id)"
											>
												<td class="px-6 py-4">
													{{ pdfBlueprint.label }}
												</td>
												<td class="px-6 py-4 text-right">
													<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="!pdfBlueprints" class="flex flex-grow justify-center w-full opacity-75">
					<LoadingSpinner />
				</div>
				<div v-else>{{ $t('no_entries_found') }}</div>
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import RouteWatcher from '@/mixins/RouteWatcher';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Forbidden from '@/views/default/Forbidden.vue';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import PDFBlueprintRepository from '@/api/repositories/PDFBlueprintRepository';
import { getL2AdminID } from '@/helpers/Utils';

export default {
	name: 'Forms',
	components: { Forbidden, LoadingSpinner, BaseHeader },
	mixins: [RouteWatcher, Authentication, AppContainerMixin],
	data() {
		return {
			pdfBlueprints: null,
			isLoading: false,
		};
	},
	methods: {
		onRouteChange() {
			this.isLoading = true;
			if (this.isUserAllowedInLevel2 && this.isAuthenticatedUserInGroupAdmin) {
				if (this.$store.getters.getUser.person.company.id === getL2AdminID()) {
					this.getAdminPDFBlueprints();
				} else {
					this.getPdfBlueprints();
				}
			}
		},
		redirectToTarget(id) {
			this.$router.push({
				name: 'PdfBlueprintsEdit',
				params: { id: id },
			});
		},
		getPdfBlueprints() {
			this.isLoading = true;
			new PDFBlueprintRepository()
				.getAllBlueprints()
				.then(response => {
					this.pdfBlueprints = response.data;
				})
				.catch(e => {
					console.log(e);
				});
		},
		getAdminPDFBlueprints() {
			this.isLoading = true;
			new PDFBlueprintRepository()
				.getBlueprintSamples()
				.then(response => {
					this.pdfBlueprints = response.data;
				})
				.catch(e => {
					console.log(e);
				});
		},
	},
};
</script>

<style scoped></style>
